// Meet member operations — list current members on a room, add one or more
// members by user_id. Server-side RLS (`meet_members_insert` policy) allows
// owner-add and self-join; the surfaces/meet.js handler stamps user_id from
// auth only when the body didn't supply one.
//
// camelCase at the boundary; snake_case on the row. Same boundary chat's
// member helpers use.
import { getSDK } from '@symbo-ls/workspace-shared/functions/sdk.js'

export const listMeetMembers = async function (roomId) {
  if (!roomId) return []
  try {
    const res = await getSDK().execute(
      'workspaceProject.meet.members',
      'list',
      { roomId }
    )
    const rows = res?.data || res || []
    return (Array.isArray(rows) ? rows : []).map((r) => ({
      userId: r.user_id,
      role: r.role || 'member',
      roomId: r.room_id
    }))
  } catch (err) {
    console.warn('[listMeetMembers]', err?.message || err)
    return []
  }
}

export const addMeetMember = async function ({ roomId, userId, role = 'member' }) {
  if (!roomId || !userId) return false
  try {
    await getSDK().execute(
      'workspaceProject.meet.members',
      'create',
      { roomId, payload: { user_id: userId, role } }
    )
    return true
  } catch (err) {
    console.warn('[addMeetMember]', err?.message || err)
    return false
  }
}
